import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../../../../app/actions/generalActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardFooter
} from "../../../../../../_metronic/_partials/controls";
import { ObjectsUIProvider } from "../ObjectsUIContext";
import { ObjectEditForm } from "./ObjectEditForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export function ObjectEdit({
  basePath,
  isFullAccess,
  api,
  prepareFilter,
  currentState,
  initObject,
  formFields,
  otherFields,
  ObjectEditSchema,
  otherTabs,
  history,
  match: {
    params: { id },
  },
  auditEdit = false,
  methodName
}) {
  // Subheader
  const suhbeader = useSubheader();

  const intl = useIntl();
  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState();
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, objectForEdit } = useSelector(
    (state) => ({
      actionsLoading: currentState.actionsLoading,
      objectForEdit: currentState.objectForEdit,
    }),
    shallowEqual
  );

  const { name } = currentState;

  useEffect(() => {

    if (!auditEdit) {
      dispatch(actions.fetchObject(api, name, id, methodName));
    }
    else {
      //setTab("questionlist")
      //dispatch(actions.fetchObject("api/ViewFormTypePlace", "auditListPlaces", id));
      dispatch(actions.fetchObject("api/ViewFormTypePlace", "auditListPlaces", id)).then(() =>
        setTab("questionlist")
      );
    }
  }, [id, dispatch]);

  const { auditListState } = useSelector(
    (state) => ({ auditListState: state["auditListPlaces"] }),
    shallowEqual
  );
  // useEffect(() => {
  //   setTab("questionlist")
  // }, [auditListState.objectForEdit]);

  useEffect(() => {
    let _title = id ? "" : intl.formatMessage({ id: "MODULES.GENERAL.ADDNEWRECORD" });
    if (objectForEdit && id) {
      _title = intl.formatMessage({ id: "MODULES.GENERAL.EDITRECORD" });
    }

    setTitle(_title);
    suhbeader.setTitle(_title);

  }, [objectForEdit, id]);

  const saveObject = (values) => {
    if (name === "questions" && values.categoryId && (values.categoryId === "0" || values.categoryId === 0))
      values.categoryId = null;

    if (!id) {
      dispatch(actions.createObject(api, name, values)).then(() => backToObjectsList());
    } else {
      dispatch(actions.updateObject(api, name, values)).then(() => backToObjectsList());
    }
  };

  const btnRef = useRef();
  const saveObjectClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToObjectsList = () => {
    history.push(basePath);
  };



  const getTab = (item) => {

    if ((item.tab === "questionlist") && id) {
      // var obj = auditListState.entities.find(q => q.id === +id)
      var obj = auditListState.objectForEdit

      return <item.component
        id={obj.formTypeId}
        otherId={obj.auditListId}
        nextId={obj.auditListFormId}
      />;
    }
    else
      if ((tab === item.tab) && id) {
        return <item.component id={+id} />;
      }
  };

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>

      </CardHeader>
      <CardBody>
        <ul className="nav nav-otherTabs nav-otherTabs-line " role="tablist">
          {!auditEdit && <li className="nav-item" onClick={() => setTab("basic")}>
            <a
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle="tab"
              role="tab"
              aria-selected={(tab === "basic").toString()}
            >
              {otherTabs && intl.formatMessage({ id: "ASID.TABS.BASEINFO" })}

            </a>
          </li>}

          {otherTabs && otherTabs.map(curTab =>
            <>
              {" "}
              <li key={curTab.id} className="nav-item" onClick={() => setTab(curTab.tab)}>
                <a
                  className={`nav-link ${tab === curTab.tab && "active"}`}
                  data-toggle="tab"
                  role="button"
                  aria-selected={(tab === curTab.tab).toString()}
                >
                  {intl.formatMessage({ id: curTab.title })}
                </a>
              </li>
            </>
          )}


        </ul>
        <div className="mt-5">

          {!auditEdit && tab === "basic" && (
            <ObjectEditForm
              actionsLoading={actionsLoading}
              object={objectForEdit || initObject}
              btnRef={btnRef}
              saveObject={saveObject}
              formFields={formFields}
              otherFields={otherFields}
              ObjectEditSchema={ObjectEditSchema}
              isFullAccess={isFullAccess}
              prepareFilter={prepareFilter}
            />

          )}


          {otherTabs && tab !== "basic" && otherTabs.map(item =>
            getTab(item)
          )}

        </div>
      </CardBody>
      <CardFooter>
        <CardHeaderToolbar>

          {/* {`  `}
            <button className="btn btn-light ml-2" disabled={!isFullAccess}>
              <i className="fa fa-redo"></i>
              {intl.formatMessage({ id: "MODULES.GENERAL.BUTTONRESET" })}
            </button> */}

          {!auditEdit && tab === "basic" && <button
            type="submit"
            className="btn btn-primary ml-2 float-right"
            onClick={saveObjectClick}
            disabled={!isFullAccess}
          >
            {intl.formatMessage({ id: "MODULES.GENERAL.BUTTONSAVE" })}

          </button>}
          {`  `}
          <button
            type="button"
            onClick={backToObjectsList}
            className="btn btn-light float-right"
          >
            <i className="fa fa-arrow-left"></i>
            {intl.formatMessage({ id: "MODULES.GENERAL.BUTTONBACK" })}
          </button>
        </CardHeaderToolbar>
      </CardFooter>
    </Card>
  );
}
